var map = {
	"./automatically-credit-player-activity/activity-assignment.html": "app/views/plugins/workflow-activities/automatically-credit-player-activity/activity-assignment.html",
	"./brand-admin-activity/activity-assignment.html": "app/views/plugins/workflow-activities/brand-admin-activity/activity-assignment.html",
	"./credit-player-activity/activity-assignment.html": "app/views/plugins/workflow-activities/credit-player-activity/activity-assignment.html",
	"./credited-to-player-confirmation-activity/activity-assignment.html": "app/views/plugins/workflow-activities/credited-to-player-confirmation-activity/activity-assignment.html",
	"./insurer-activity/activity-assignment.html": "app/views/plugins/workflow-activities/insurer-activity/activity-assignment.html",
	"./platform-admin-activity/activity-assignment.html": "app/views/plugins/workflow-activities/platform-admin-activity/activity-assignment.html",
	"./platform-admin-threshold-activity/activity-assignment.html": "app/views/plugins/workflow-activities/platform-admin-threshold-activity/activity-assignment.html"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./ClientApp/app/views/plugins/workflow-activities sync recursive \\.html$";